import React, { useEffect, useState } from "react";
import EventLoginForm from "./EventLoginForm";
// import EventLoginCheckoutForm from "./EventLoginCheckoutForm";
import EventRegisterCheckoutForm from "./EventRegisterCheckoutForm";
import { useDispatch, useSelector } from "react-redux";
import EventGuestCheckoutForm from "./EventGuestCheckoutForm";
import axios from "axios";
import { resetTimer } from "../../app/features/timer/timerSlice";
import { store } from "../../app/store";
import AllTickets from "./AllTickets";
import { resetAskSignup, resetGuest, setAskTicket } from "../../app/features/user/userSlice";
import { resetSale, setBooking } from "../../app/features/event/eventSlice";
import PaymentForm from "../payments/PaymentForm";
import { useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { useLocation } from "react-router-dom";
import AppModal from "../common/AppModal";
import EventDescription from "./EventDescription";
import { hasInternalTickets, isExternalEvent, openExternalTicketing } from "../../utils/eventTicketing";

const EventTicketsModal = ({ id, closeId }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const promo_code = queryParams.get("promo_code") || null;

  let user = useSelector((state) => state.user.user);

  const askSignup = useSelector((state) => state.user.askSignup);
  const askTicket = useSelector((state) => state.user.askTicket);
  const userGuest = useSelector((state) => state.user.guest);
  const homeModal = useSelector((state) => state.user.homeModal);
  const booking = useSelector((state) => state.event.booking);
  const cart = useSelector((state) => state.event.cart);
  const currentEvent = useSelector((state) => state.event.currentEvent);
  const items = useSelector((state) => state.event.items);
  const dispatch = useDispatch();
  const history = useHistory();
  const [bookingLoading, setBookingLoading] = useState(false);

  const handleModalClose = async () => {
    const currentItems = store.getState().event.items;
    const tickets = Object.values(currentItems).reduce((acc, el) => {
      if (el != null) {
        acc.push({
          ticket_id: el.ticket_id,
          quantity: el.quantity,
        });
      }
      return acc;
    }, []);

    await axios.request({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/api/unhold_tickets`,
      data: { tickets: tickets },
      headers: {
        Authorization: process.env.REACT_APP_API_KEY,
      },
    });
    dispatch(resetSale());
    dispatch(resetTimer());
    dispatch(setAskTicket());
    dispatch(resetAskSignup());
    dispatch(resetGuest());
  };

  useEffect(() => {
    const modalEl = document.getElementById("appModal");

    if (modalEl) modalEl.addEventListener("hidden.bs.modal", handleModalClose);

    return () => {
      if (modalEl) modalEl.removeEventListener("hidden.bs.modal", handleModalClose);
    };
  }, [booking]);

  const createBooking = async (formData, isGuest = false, userParam = null) => {
    if (isExternalEvent(currentEvent)) {
      openExternalTicketing(currentEvent);
      return;
    }
    setBookingLoading(true);

    const userToUse = userParam || user;
    var filteredItems = Object.values(items).filter(function (el) {
      return el != null;
    });
    var bookingData = {
      first_name: userToUse ? userToUse.first_name : formData.first_name,
      last_name: userToUse ? userToUse.last_name : formData.last_name,
      email: userToUse ? userToUse.email : formData.email,
      phone: userToUse ? userToUse.phone : formData.phone,
      address1: userToUse ? userToUse.address1 : formData.street_address || formData.address1,
      address2: userToUse ? userToUse.address2 : formData.address2,
      location_id: userToUse ? userToUse.location : formData.location_id,
      postal_code: userToUse ? userToUse.postal_code : formData.postal_code,
      buyer_id: userToUse ? userToUse.id : formData.id ? formData.id : null,
      total: cart.grandTotal,
      subtotal: cart.subTotal,
      booking_fee: cart.bookingFee,
      event_id: currentEvent.id,
      user_id: currentEvent.user_id,
      coupon_id: cart.coupon_id ? cart.coupon_id : null,
      discount_amount: parseFloat(cart.discount_amount),
      status: cart.grandTotal === 0 ? 1 : 0,
      items: filteredItems,
      promo_code: promo_code,
    };

    if (isGuest) {
      await axios
        .request({
          method: "GET",
          url: `${process.env.REACT_APP_BASE_URL}/api/sanctum/csrf-cookie`,
        })
        .then(async (sanRep) => {
          await axios
            .request({
              method: "POST",
              url: `${process.env.REACT_APP_BASE_URL}/api/register`,
              data: formData,
            })
            .then(async (registerResponse) => {
              bookingData.buyer_id = registerResponse.data.data.id;
              await axios
                .request({
                  method: "POST",
                  url: `${process.env.REACT_APP_BASE_URL}/api/bookings`,
                  data: bookingData,
                  headers: {
                    Authorization: process.env.REACT_APP_API_KEY,
                  },
                })
                .then(async function (response) {
                  setBookingLoading(false);
                  if (cart.grandTotal === 0) {
                    history.push(`/ticket/${response.data.data.slug}`);
                    window.location.reload();
                  } else {
                    dispatch(setBooking(response.data.data));
                  }
                });
            });
        });
    } else {
      if (!userToUse) return; // need user for non-guest
      bookingData.buyer_id = userToUse.id;
      await axios
        .request({
          method: "GET",
          url: `${process.env.REACT_APP_BASE_URL}/api/sanctum/csrf-cookie`,
        })
        .then(async (sanRep) => {
          await axios
            .request({
              method: "GET",
              url: `${process.env.REACT_APP_BASE_URL}/api/users/${currentEvent.user_id}`,
              headers: {
                Authorization: process.env.REACT_APP_API_KEY,
              },
            })
            .then(async function (userResponse) {
              await axios
                .request({
                  method: "POST",
                  url: `${process.env.REACT_APP_BASE_URL}/api/bookings`,
                  data: bookingData,
                  headers: {
                    Authorization: process.env.REACT_APP_API_KEY,
                  },
                })
                .then(async function (response) {
                  setBookingLoading(false);
                  if (cart.grandTotal === 0) {
                    history.push(`/ticket/${response.data.data.slug}`);
                    window.location.reload();
                  } else {
                    dispatch(setBooking(response.data.data));
                  }
                });
            });
        });
    }
  };

  if (isExternalEvent(currentEvent)) {
    return null;
  }

  return (
    <AppModal id={id} closeId={closeId} onClose={() => handleModalClose}>
      <div>
        {bookingLoading && !booking && (
          <div className="text-center">
            <BeatLoader color="#C6153B" />
            <h4 className="mt-3" style={{ color: "#C6153B" }}>
              Creating Booking...
            </h4>
          </div>
        )}
        {!askSignup && !userGuest && askTicket && !booking && !bookingLoading && homeModal && !isExternalEvent(currentEvent) && (
          <EventDescription currentEvent={currentEvent} />
        )}
        {!askSignup && !userGuest && askTicket && !booking && !bookingLoading && !homeModal && hasInternalTickets(currentEvent) && <AllTickets createBooking={createBooking} />}
        {!user && !askSignup && !userGuest && !askTicket && !booking && !bookingLoading && !homeModal && <EventLoginForm createBooking={createBooking} />}
        {!user && !askSignup && userGuest && !askTicket && !booking && !bookingLoading && !homeModal && <EventGuestCheckoutForm createBooking={createBooking} />}
        {!user && askSignup && !askTicket && !booking && !bookingLoading && !homeModal && <EventRegisterCheckoutForm createBooking={createBooking} />}
        {booking && <PaymentForm />}
      </div>
    </AppModal>
  );
};

export default EventTicketsModal;
